export type SqlTokenKind =
  'keyword' | 'function' | 'literal' | 'reference' | 'comment' | 'plain';

export interface SqlToken {
  kind: SqlTokenKind;
  text: string;
}

const KEYWORDS = new Set(
  'select from where and or not in is null as over partition by order range between interval preceding following current row rows group having limit join left right inner outer on case when then else end distinct like rlike asc desc minutes hours days union all with'.split(
    ' '
  )
);

const PATTERN =
  /(--[^\n]*)|('(?:[^']|'')*'|\b\d+(?:\.\d+)?\b)|(@\w+)|([A-Za-z_][\w.]*)(?=\s*\()|([A-Za-z_][\w.]*)|(\s+|.)/g;

/** Splits one line of Spark SQL into the spans `CodeBlock` colours (DESIGN.md §8.9). */
export const tokenizeSql = (line: string): SqlToken[] => {
  const tokens: SqlToken[] = [];
  for (const match of line.matchAll(PATTERN)) {
    const [text, comment, literal, reference, fn, word] = match;
    const kind: SqlTokenKind = comment
      ? 'comment'
      : literal
        ? 'literal'
        : reference
          ? 'reference'
          : fn
            ? KEYWORDS.has(fn.toLowerCase())
              ? 'keyword'
              : 'function'
            : word && KEYWORDS.has(word.toLowerCase())
              ? 'keyword'
              : 'plain';
    const last = tokens.at(-1);
    if (last && last.kind === kind && kind === 'plain') last.text += text;
    else tokens.push({ kind, text });
  }
  return tokens;
};
